import type { AllOtherPlatform, OtherPlatformType } from '@lighthouse/shared'

import type { HttpResp } from '@/http'
import http from '@/http'

import { JsonContentType } from './constant'
import type { UpdateIntegrationPayload } from './types'

/**
 * 获取第三方应用集成的所有应用账户
 * @return {*}
 */
export async function getOtherPlatforms(): Promise<AllOtherPlatform> {
    const res = await http.get<unknown, HttpResp<AllOtherPlatform>>('/api/v1/integration/otherPlatforms')
    return res.content
}
/**
 * @description 添加集成账号
 * @param {string} WeComAccount
 * @return {*}  {Promise<string | undefined>}
 */
export async function addIntegration(type: OtherPlatformType): Promise<boolean> {
    const res = await http.put<unknown, HttpResp<string>>('api/v1/integration/createIntegration', {
        type
    })
    return res.success
}

/** Creates a distinct WeChat merchant without changing other integration callers. */
export async function createWechatPaymentAccount(): Promise<string | undefined> {
    const res = await http.put<unknown, HttpResp<string>>('api/v1/integration/createIntegration', { type: 'WECHAT_PAY' })
    return res.success ? res.content : undefined
}

/**
 * @description 删除集成账号
 * @param {string} id
 * @return {*}  {Promise<string | undefined>}
 */
export async function deleteIntegration(id: string): Promise<boolean> {
    const res = await http.delete<unknown, HttpResp<string>>('api/v1/integration/deleteIntegration', {
        params: {
            id
        }
    })
    return res.success
}

/**
 * @description 更新集成账号
 * @param {string} WeComAccount
 * @return {*}  {Promise<string | undefined>}
 */
export async function updateIntegration(params: UpdateIntegrationPayload): Promise<boolean> {
    const res = await http.post<unknown, HttpResp<string>>('api/v1/integration/updateIntegration', params, {
        headers: JsonContentType
    })
    return res.success
}

export type WeChatDeliveryCompany = {
    deliveryId: string
    deliveryName: string
}

/**
 * 获取微信物流运力列表
 */
export async function getWechatDeliveryList(): Promise<WeChatDeliveryCompany[]> {
    const res = await http.get<unknown, HttpResp<WeChatDeliveryCompany[]>>('api/v1/integration/wechatDeliveryList')
    return res.content || []
}
